import React from 'react';
import PropTypes from 'prop-types';

const SmtpAccountHelperText = ({ isConnected }) => {
  const statusColor = isConnected ? '#28a745' : '#dc3545';
  const statusBgColor = isConnected
    ? 'rgba(40, 167, 69, 0.15)'
    : 'rgba(220, 53, 69, 0.15)';
  const statusBorderColor = isConnected
    ? 'rgba(40, 167, 69, 0.35)'
    : 'rgba(220, 53, 69, 0.35)';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10
      }}
    >
      <span>SMTP Client</span>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '3px 10px',
          borderRadius: 999,
          backgroundColor: statusBgColor,
          border: `1px solid ${statusBorderColor}`,
          color: statusColor,
          fontWeight: 600,
          fontSize: 12,
          lineHeight: '16px'
        }}
      >
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: statusColor,
            display: 'inline-block'
          }}
        />
        {isConnected ? 'Connected' : 'Disconnected'}
      </span>
    </span>
  );
};

SmtpAccountHelperText.propTypes = {
  isConnected: PropTypes.bool.isRequired
};

export default SmtpAccountHelperText;
